import React from 'react';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { Modal } from 'react-bootstrap';
import { Box, Button } from '@qwealth/qcore';
import { TrustedContactData, TrustedContactForm, trustedContactValidator } from '@qwealth/kyc';
import '@emotion/core';
interface Props {
  shouldShowModal: boolean;
  onClose: () => void;
  initialValues: TrustedContactData;
  updateFormValues: (values: any) => Promise<void>;
}

const EditTrusted: React.FC<Props> = ({
  shouldShowModal,
  onClose,
  initialValues,
  updateFormValues
}) => {
  const submitHandler = async (values) => {
    await updateFormValues(values);
    onClose();
  };

  return (
    <Form
      validate={(values) => trustedContactValidator(values)}
      onSubmit={submitHandler}
      initialValues={initialValues}
      mutators={{
        ...arrayMutators
      }}
      render={({ handleSubmit }) => (
        <Modal onHide={onClose} show={shouldShowModal} size="xl">
          <Modal.Header closeButton>
            <Box textStyle="sectionTitle">Edit Trusted Contact Information</Box>
          </Modal.Header>
          <Modal.Body>
            <TrustedContactForm isEditing isUserClient />
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" onClick={handleSubmit}>
              Update
            </Button>
            <Button variant="outline" onClick={onClose}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    />
  );
};

export default EditTrusted;
